import { render, staticRenderFns } from "./AnswerPreviewPage.vue?vue&type=template&id=5722cc3e&scoped=true"
import script from "./AnswerPreviewPage.vue?vue&type=script&lang=js"
export * from "./AnswerPreviewPage.vue?vue&type=script&lang=js"
import style0 from "./AnswerPreviewPage.vue?vue&type=style&index=0&id=5722cc3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5722cc3e",
  null
  
)

export default component.exports